/* eslint-disable */
import { withStyles } from '@material-ui/core';
import Button from '@material-ui/core/Button';
import CircularProgress from '@material-ui/core/CircularProgress';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';
import withMobileDialog from '@material-ui/core/withMobileDialog';
import React from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { bindActionCreators, compose } from 'redux';
import { ORDER_API_DATE_FORMAT } from '../../Constants/Order/Order.constants';
import withServices from '../../Contexts/Services/WithServices.context';
import i18nLocaleSelector from '../../State/Store/I18n/Selectors/I18nLocale.selector';
import ordersActionCreators from '../../State/Store/Orders/Orders.actions';
import orderConfirmationDoneSelector from '../../State/Store/Orders/Selectors/OrderConfirmationDone.selector';
import orderConfirmedSelector from '../../State/Store/Orders/Selectors/OrderConfirmed.selector';
import ordersLinkedSelector from '../../State/Store/Orders/Selectors/OrdersLinked.selector';
import ordersLinkedLoadingSelector from '../../State/Store/Orders/Selectors/OrdersLinkedLoading.selector';
import uiActionCreators from '../../State/Store/UI/UI.actions';
import { UI_NO_BUTTON_CLICKED, UI_YES_BUTTON_CLICKED } from '../../State/Store/UI/UI.types';
import toDisplayUnit from '../../Support/Converters/ToDisplayUnit/ConvertersToDisplayUnit.support';
import dateOnly from '../../Support/DateTime/DateOnly/DateTimeDateOnly.support';
import formatWithTime from '../../Support/DateTime/FormatWithTime/DateTimeFormatWithTime.support';
import getTimezoneOffset from '../../Support/DateTime/GetTimezoneOffset/DateTimeGetTimezoneOffset.support';
import generateHash from '../../Support/Generators/GenerateHash/GeneratorsGenerateHash.support';
import htmlDecodeEntities from '../../Support/Html/DecodeEntities/HtmlDecodeEntities.support';
import themeCreateInjectableStyles from '../../Support/Theme/CreateInjectableStyles/ThemeCreateInjectableStyles.support';
import I18n from '../I18n/I18n.component';
import OrderConfirmationDialogPropTypes from './OrderConfirmationDialog.component.props';
import orderConfirmationDialogtyles from './OrderConfirmationDialog.component.styles';
import { MFSDR } from 'Constants/MouseFlow/SensitiveDataReplacer';

/**
 * OrderConfirmationDialogComponent
 * @export
 * @class OrderConfirmationDialogComponent
 * @extends {React.Component<OrderConfirmationDialogComponentComposedProps, OrderConfirmationDialogComponentState>}
 */
export class OrderConfirmationDialogComponent extends React.Component {
  /**
   * The `props` to seed when any specific prop receives an `undefined` value. NOT a `null` value
   * @static
   * @type {Partial<OrderConfirmationDialogComponentProps>}
   * @memberof OrderConfirmationDialogComponent
   */
  static defaultProps = {
    open: false,
  };

  /**
   * The name of the Component to display when debugging
   * @static
   * @type {`OrderConfirmationDialog`}
   * @memberof OrderConfirmationDialogComponent
   */
  static displayName = `OrderConfirmationDialog`;

  /**
   * The values to use to apply runtime typechecking on the props
   * @static
   * @type {object}
   * @memberof OrderConfirmationDialogComponent
   */
  static propTypes = OrderConfirmationDialogPropTypes;

  /**
   * Data specific to the `<OrderConfirmationDialogComponent />` instance
   * @type {OrderConfirmationDialogComponentState}
   * @memberof OrderConfirmationDialogComponent
   */
  state = {};

  /**
   * componentDidUpdate
   * @param {React.props} prevProps The `props` prior to the update
   * @returns {void} void
   * @memberof OrderConfirmationDialogComponent
   */
  componentDidUpdate(prevProps) {
    const { open } = this.props;
    const isOpen = !prevProps.open && open;
    if (!isOpen) {
      return;
    }
    const { services, summary, actions } = this.props;
    if (!services.authService.isAuthenticated()) {
      return;
    }
    if (!summary) {
      return;
    }
    const { orderCode, startTime } = summary;
    const requestPayload = {
      date: dateOnly(startTime, ORDER_API_DATE_FORMAT),
      orderCode,
    };
    actions.ordersFindLinked(requestPayload);
  }

  /**
   * Cancel the Order
   * @returns {void} void
   * @memberof OrderConfirmationDialogComponent
   */
  cancelOrder = () => {
    const { services, summary, actions } = this.props;
    if (!services.authService.isAuthenticated()) {
      return;
    }
    if (!summary) {
      return;
    }
    const { ordersLinked, orderKey } = this.props;
    const { companyCode, rawOrderCode } = ordersLinked;
    const { startTime } = summary;
    const timezone = getTimezoneOffset(startTime);
    const requestPayload = {
      companyCode,
      date: dateOnly(startTime, ORDER_API_DATE_FORMAT),
      orderCode: rawOrderCode,
      orderKey,
      timezone,
    };
    actions.ordersCancelOrder(requestPayload);
  };

  /**
   * Confirm the Order
   * @returns {void} void
   * @memberof OrderConfirmationDialogComponent
   */
  confirmOrder = () => {
    const { orderKey, services, summary, actions } = this.props;
    if (!services.authService.isAuthenticated()) {
      return;
    }
    if (!summary) {
      return;
    }
    const { startTime, orderCode } = summary;
    const requestPayload = {
      date: dateOnly(startTime, ORDER_API_DATE_FORMAT),
      orderCode,
      orderKey,
    };
    actions.ordersConfirmOrder(requestPayload);
  };

  /**
   * onNoClick
   * @returns {void} void
   * @memberof OrderConfirmationDialogComponent
   */
  onNoClick = () => {
    const { actions, i18nSection, onNoClick } = this.props;
    actions.uiTriggered({
      payload: {
        data: {
          name: i18nSection,
        },
      },
      type: UI_NO_BUTTON_CLICKED,
    });
    onNoClick();
  };

  /**
   * onYesClick
   * @returns {void} void
   * @memberof OrderConfirmationDialogComponent
   */
  onYesClick = () => {
    const confirmStrategy = {
      OrderCancellation: {
        confirmFunction: this.cancelOrder,
      },
      OrderConfirmation: {
        confirmFunction: this.confirmOrder,
      },
    };
    const { actions, i18nSection, onYesClick } = this.props;
    const { confirmFunction } = confirmStrategy[i18nSection];
    actions.uiTriggered({
      payload: {
        data: {
          name: i18nSection,
        },
      },
      type: UI_YES_BUTTON_CLICKED,
    });
    onYesClick();
    if (confirmFunction) {
      confirmFunction();
    }
  };

  /**
   * Render the confirmation items
   * @returns {React.Component} The rendered confirmation items
   * @memberof OrderConfirmationDialogComponent
   */
  renderConfirmationItems() {
    const { ordersLinkedLoading } = this.props;
    if (ordersLinkedLoading) {
      return this.renderLoader();
    }
    const { ordersLinked } = this.props;
    const { linked = [] } = ordersLinked || {};
    const items = linked.map(({ qty, startTime, subTitle }) => ({
      qty,
      startTime,
      subTitle,
    }));
    return (
      <Grid container direction="column" justify="center" spacing={2}>
        {items.map(this.renderConfirmationLineItem)}
      </Grid>
    );
  }

  /**
   * Render a single confirmation item
   * @param {any} any The item details
   * @param {any} key The key
   * @returns {React.Component} The rendered single confirmation item
   * @memberof OrderConfirmationDialogComponent
   */
  renderConfirmationLineItem = ({ startTime, subTitle, qty }, key) => {
    const { lang, summary } = this.props;
    const { ordered, uom } = qty || {};
    const unit = toDisplayUnit(uom);
    const time = formatWithTime(startTime, `h:mm a, ddd D MMM YYYY`, { locale: lang });
    const decodedSubTitle = htmlDecodeEntities(subTitle);
    return (
      <Grid container item key={`${generateHash(summary)}-${key}`}>
        <Grid item sm={4} xs={12}>
          <Typography variant="subtitle1">{time}</Typography>
        </Grid>
        <Grid item sm xs={12}>
          <Typography variant="subtitle1">{decodedSubTitle}</Typography>
        </Grid>
        <Grid item sm={1} xs={12}>
          <Typography variant="subtitle1">{`${ordered}${unit}`}</Typography>
        </Grid>
      </Grid>
    );
  };

  /**
   * Render the loader
   * @returns {React.Component} The rendered loader
   * @memberof OrderConfirmationDialogComponent
   */
  renderLoader() {
    return (
      <Grid container justify="center">
        <CircularProgress />
      </Grid>
    );
  }

  /**
   * Render the component
   * @returns {React.Component} The rendered `<OrderConfirmationDialogComponent />`
   * @memberof OrderConfirmationDialogComponent
   */
  render() {
    const { classes, fullScreen, i18nSection, onYesClick, open, ordersLinked, summary } = this.props;
    const { linked = [] } = ordersLinked || {};
    const { title: address } = summary;
    const hasLinkedOrders = linked.length > 0;
    const title = `OrderService.${i18nSection}.Title`;
    const subTitle = `OrderService.${i18nSection}.SubTitle`;
    return (
      <Dialog disableBackdropClick fullScreen={fullScreen} onClose={onYesClick} open={open}>
        <DialogTitle>
          <Grid container>
            <Grid item xs={12}>
              <I18n align="center" textTransform="none" variant="h6">
                {title}
              </I18n>
            </Grid>
            <Grid item xs={12}>
              <Typography align="center" variant="h6" data-mf-replace-inner={MFSDR}>
                {address}
              </Typography>
            </Grid>
          </Grid>
        </DialogTitle>
        <DialogContent>{this.renderConfirmationItems()}</DialogContent>
        <DialogActions>
          <Grid container direction="column">
            {hasLinkedOrders && (
              <Grid classes={{ item: classes.confirmationLabel }} item xs={12}>
                <I18n align="center" textTransform="none" variant="h6">
                  {subTitle}
                </I18n>
              </Grid>
            )}
            <Grid container item spacing={1}>
              {hasLinkedOrders && (
                <Grid item xs={6}>
                  <Button autoFocus className={classes.ctaButtons} color="secondary" fullWidth onClick={this.onYesClick} size="large" variant="contained">
                    <I18n variant="subtitle1">OrderService.YesButtonLabel</I18n>
                  </Button>
                </Grid>
              )}
              <Grid item xs>
                <Button autoFocus className={classes.ctaButtons} fullWidth onClick={this.onNoClick} size="large" variant="contained">
                  <I18n variant="subtitle1">OrderService.NotNowButtonLabel</I18n>
                </Button>
              </Grid>
            </Grid>
          </Grid>
        </DialogActions>
      </Dialog>
    );
  }
}

/** @type {React.ComponentClass<OrderConfirmationDialogComponentProps>} */
const OrderConfirmationDialog = compose(
  withServices,
  withMobileDialog({ breakpoint: `xs` }),
  withRouter,
  withStyles(themeCreateInjectableStyles(orderConfirmationDialogtyles), { withTheme: true }),
  connect(
    (state) => {
      return {
        locale: i18nLocaleSelector(state),
        orderConfirmationDone: orderConfirmationDoneSelector(state),
        orderConfirmed: orderConfirmedSelector(state),
        ordersLinked: ordersLinkedSelector(state),
        ordersLinkedLoading: ordersLinkedLoadingSelector(state),
      };
    },
    (dispatch) => ({
      actions: bindActionCreators(
        {
          ...ordersActionCreators,
          ...uiActionCreators,
        },
        dispatch,
      ),
    }),
  ),
)(OrderConfirmationDialogComponent);

export default OrderConfirmationDialog;
